import { consultFormService, consultHistoryService } from '@/_services'
import { indexedDB } from '@/_helpers'

function newConsultSteps() {
  return Object.assign(
    {},
    {
      ClientDetails: {
        title: 'Client',
        visited: true,
        complete: false,
        dependsOn: [],
        requiredFields: ['client_consulter'],
      },
      AnimalNumbers: {
        title: 'Animal Numbers',
        visited: true,
        complete: false,
        dependsOn: [],
      },
    }
  )
}

const state = {
  version: '0.2.0',
  client: null,
  currentIndex: 1,
  consultSteps: newConsultSteps(),
  models: {},
  backendErrors: {},
  signed: false,
  dbName: 'spring-consult',
  endpoints: {
    get: '/clients/{client}/spring_consult/{season}',
    post: '/clients/{client}/spring_consult/{season}/save',
  },
}

const actions = {
  saveConsultData({ commit, state }, { clientId, season }) {
    let endpoint = state.endpoints.post.replace('{client}', clientId).replace('{season}', season)

    return indexedDB.get(clientId, state.dbName).then((consultData) => {
      return consultFormService.saveClientConsultData(consultData.models, endpoint).catch((error) => {
        // return dispatch('addBackendErrors', {clientId: state.client, errors: error.response.data})
        if (error.response.status == 400) {
          commit('addBackendErrors', error.response.data)
        }
        return Promise.reject(error)
      })
    })
  },
  getReadOnlyData({ commit, state }, consultParams) {
    let endpoint = state.endpoints.get
      .replace('{client}', consultParams.clientId)
      .replace('{season}', consultParams.season)
    return consultHistoryService.getConsultHistoryData(endpoint).then(
      (models) => {
        commit('resetConsultSteps', newConsultSteps())
        commit('setClient', consultParams.clientId)
        commit('setModels', models)
      },
      (error) => {
        return Promise.reject(error)
      }
    )
  },
  getConsultData({ commit, dispatch, state }, { clientId, season }) {
    return indexedDB.get(state.client, state.dbName).then((consultState) => {
      if (consultState && consultState.version === state.version) {
        commit('setModels', consultState.models)
        commit('resetConsultSteps', consultState.consultSteps)
        commit('updateStateFromIDB', consultState)
      } else {
        let endpoint = state.endpoints.get.replace('{client}', clientId).replace('{season}', season)

        return consultFormService.getClientConsultData(endpoint).then(
          (models) => {
            commit('setClient', clientId)
            commit('resetConsultSteps', newConsultSteps())
            commit('setModels', models)
            dispatch('backupState', { models })
          },
          (error) => {
            return Promise.reject(error)
          }
        )
      }
    })
  },
}
const mutations = {
  resetConsultSteps(state, originalSteps)
  {
    state.consultSteps = Object.assign({}, originalSteps)
  },
}
const getters = {}

export default {
  stateMixin: state,
  actionsMixin: actions,
  mutationsMixin: mutations,
  gettersMixin: getters,
}
